export default __webpack_public_path__ + "static/media/logo_inter.32f0ed5e.svg";